import {Component, OnInit} from '@angular/core';
import {ErrorStateMatcher, ThemePalette} from '@angular/material/core';
import {AbstractControl, FormControl, FormGroup, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {OttVoucherService} from '../../../services/ott-voucher/ott-voucher.service';
import {InitiateTransactionResponse} from '../../../interfaces/ott-voucher/InitiateTransactionResponse';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Session} from 'src/app/interfaces/session-data';
import {Observable} from 'rxjs';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-voucher-input',
  templateUrl: './voucher-input.component.html',
  styleUrls: ['./voucher-input.component.scss']
})
export class VoucherInputComponent implements OnInit {

  public loading = false;
  public paymentOptionsLoadedJustify = 'space-between !important';
  public color: ThemePalette = 'primary';
  public diameter = 50;
  public voucherNumber = new FormControl('', [Validators.required]);
  public mobileNumber = new FormControl('', [Validators.required]);
  public walletClass = '';
  paymentMethod = 'secure-eft';
  paymentMethodStyling = `url('../../assets/icons/Payment_Cards/PaymentCard_ott_voucher.png') center`;
  public validationErrors = false;
  public validationErrorMessage = 'Error: ';
  matcher = new MyErrorStateMatcher();
  applicationDetailsForm: FormGroup;
  session: Session;
  mobile;
  public headerColor = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private ottVoucherService: OttVoucherService,
    private breakpointObserver: BreakpointObserver,
    private _snackBar: MatSnackBar) {

    this.headerColor = (document.getElementsByClassName('header-container')[0] as HTMLElement).style.backgroundColor;

    this.walletClass = 'wallet-method-container';
    this.loading = false;

    breakpointObserver.observe([
      Breakpoints.HandsetLandscape,
      Breakpoints.HandsetPortrait
    ]).subscribe(result => {
      this.mobile = result.matches;
    });

    this.applicationDetailsForm = new FormGroup({
      voucherNumber: this.voucherNumber,
      mobileNumber: this.mobileNumber
    });
  }

  initiateVoucherTransaction() {
    this.validationErrors = false;
    this.validationErrorMessage = 'Error: ';
    this.loading = true;
    this.ottVoucherService.initiateTransaction(this.voucherNumber.value, this.mobileNumber.value)
      .subscribe((data: InitiateTransactionResponse) => {
      sessionStorage.setItem('ott-voucher-transactionId', data.transactionId);
      sessionStorage.setItem('voucherNumber', this.voucherNumber.value);
      sessionStorage.setItem('mobileNumber', this.mobileNumber.value);
      sessionStorage.setItem('voucherValid', String(data.success));
      if (data.success) {
        this.router.navigate(['processing'], {relativeTo: this.route.parent});
      } else {
        this.loading = false;
        this.validationErrors = true;
        this.voucherNumber.setAsyncValidators(this.voucherError);
        // this.applicationDetailsForm.controls['voucherNumber'].setErrors({validationFailed: true})
        this.validationErrorMessage = data.message;
        this._snackBar.open(data.message, 'Error', {
          duration: 5000,
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
        });
        // this.router.navigate(['processing'], {relativeTo: this.route.parent});
      }
    });
  }

  voucherError(control: AbstractControl): Observable<{[key: string]: any}> {
    return Observable.create(observer => {
      if (sessionStorage.getItem('voucherValid') !== 'true') {
        observer.next({validationFailed: true});
      }
      else {
        observer.next(null);
      }
      observer.complete();
    });
  }

  cancelTransaction() {
    this.router.navigate(['transaction-status/userCancelled']);
  }

  goBack() {
    sessionStorage.setItem('goBack', 'true');
    return this.router.navigate(['virtual']);
  }
  ngOnInit(): void {
  }

  getErrorMessage() {

    if (this.voucherNumber.hasError('required')) {
      return 'You must enter a value';
    }

    if (this.mobileNumber.hasError('required')) {
      return 'You must enter a value';
    }

    if (this.validationErrors) {
      return this.validationErrorMessage;
    }
  }

}


